import {WmsLayer, TilexyzLayer, GeojsonLayer, DynamicBandLayer} from "@/services/mapbox.service"

const state = {
    layerCategories: [
        {
            name: "Bodenreflektion",
            type: "category",
            content: [
                {
                    name: "Reflektion",
                    type: "subcategory",
                    content: [
                        {
                            type: "layer",
                            id: 1
                        },
                        {
                            type: "layer",
                            id: 30
                        },
                        {
                            type: "layer",
                            id: 31
                        },
                        {
                            type: "layer",
                            id: 32
                        },
                        {
                            type: "layer",
                            id: 33
                        },
                        {
                            type: "layer",
                            id: 43
                        },
                        {
                            type: "layer_dynamic_bands",
                            id: 52
                        }
                    ]
                },
                {
                    name: "Unbedeckter Boden, Häufigkeit",
                    type: "subcategory",
                    content: [
                        {
                            type: "layer",
                            id: 2
                        }
                    ]
                },
                {
                    name: "Unbedeckter Boden, Vorkommen",
                    type: "subcategory",
                    content: [
                        {
                            type: "layer",
                            id: 3
                        }
                    ]
                }
            ]
        },
        {
            name: "Bodenfunktionen und Bodenpotenziale",
            type: "category",
            content: [
                {
                    name: "Deutschland, basierend auf BÜK1000",
                    type: "subcategory",
                    content: [
                        {
                            type: "layer",
                            id: 4
                        },
                        {
                            type: "layer",
                            id: 5
                        },
                        {
                            type: "layer",
                            id: 6
                        },
                        {
                            type: "layer",
                            id: 7
                        },
                        {
                            type: "layer",
                            id: 8
                        },
                        {
                            type: "layer",
                            id: 9
                        },
                        {
                            type: "layer",
                            id: 10
                        },
                    ]
                },
                {
                    name: "Deutschland, basierend auf BÜK200",
                    type: "subcategory",
                    content: [
                        {
                            type: "layer",
                            id: 44
                        },
                        {

                            type: "layer",
                            id: 45
                        },
                        {
                            type: "layer",
                            id: 46
                        },
                        {
                            type: "layer",
                            id: 47
                        },
                        {
                            type: "layer",
                            id: 48
                        },
                        {
                            type: "layer",
                            id: 49
                        },
                        {
                            type: "layer",
                            id: 50
                        },
                    ]
                },
                {
                    name: "Baden-Württemberg, basierend auf BK50",
                    type: "subcategory",
                    content: [
                        {
                            type: "layer",
                            id: 11
                        },
                        {

                            type: "layer",
                            id: 13
                        },
                        {
                            type: "layer",
                            id: 14
                        },
                        {
                            type: "layer",
                            id: 15
                        },
                        {
                            type: "layer",
                            id: 16
                        },
                        {
                            type: "layer",
                            id: 17
                        },
                    ]
                },
                {
                    name: "Niedersachsen, basierend auf BK50",
                    type: "subcategory",
                    content: [
                        {
                            type: "layer",
                            id: 37
                        },
                        {

                            type: "layer",
                            id: 38
                        },
                        {
                            type: "layer",
                            id: 39
                        },
                        {
                            type: "layer",
                            id: 40
                        },
                        {
                            type: "layer",
                            id: 41
                        },
                        {
                            type: "layer",
                            id: 42
                        },
                    ]
                }
            ]
        },
        {
            name: "Bodenverlust durch Versiegelung",
            type: "category",
            content: [
                {
                    type: "layer",
                    id: 53
                },
            ]
        },
        {
            name: "Messpunkte",
            type: "category",
            content: [
                {
                    type: "layer_geojson",
                    id: 18
                }
            ]
        },
        {
            name: "Abgeleitete Bodeninformationen",
            type: "category",
            content: [
                {
                    type: "layer_rastless",
                    id: 51,
                },
                {
                    type: "layer",
                    id: 34,
                },
                {
                    type: "layer",
                    id: 35,
                },
                {
                    type: "layer",
                    id: 36,
                }
            ]
        },
        {
            name: "Basiskarten",
            type: "category",
            content: [
                {
                    type: "layer",
                    id: 19
                },
                {
                    type: "layer",
                    id: 21
                },
                {

                    type: "layer",
                    id: 22
                },
                {
                    type: "layer",
                    id: 23
                },
                {
                    type: "layer",
                    id: 24
                },
                {
                    type: "layer",
                    id: 25
                },
                {
                    type: "layer",
                    id: 26
                },
                {
                    type: "layer",
                    id: 27
                },
                {
                    type: "layer",
                    id: 28
                },
                {
                    type: "layer",
                    id: 29
                }
            ]
        }
    ],
    layerInfos: {
        1: {
            layerId: 1,
            name: "Reflektion, 30 m",
            subname: "1984-2014, Pseudo-Echtfarben, © DLR",
            active: false,
            url: "https://geoservice.dlr.de/eoc/land/wms?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=SCMAP_SN_LS_1984-2014&styles=",
            func: WmsLayer,
            attribution: "© DLR (2020)",
            infoText: "Im Rahmen des Projektes SOIL-DE werden verschiedene Indikatoren zur Bewertung der Ertragsfähigkeit und Vulnerabilität landwirtschaftlich genutzter Böden in Deutschland abgeleitet und bereitgestellt. Dabei dient der am DLR entwickelte Soil Composite Mapping Processor (SCMaP) zur Identifizierung von unbedeckten Böden in Deutschland. Über einen definierbaren Zeitraum (5 bis 30 Jahre) werden mittels SCMaP aus allen verfügbaren Szenen (1984 bis 2019) der Landsat-Satellitenfamilie wolkenfreie, unbedeckte Böden ermittelt. Das Hauptprodukt der voll automatisierten Prozessierungskette stellen wolkenfreie Reflektanzkomposite dar, welche spektrale Informationen der abgeleiteten unbedeckten Böden für die definierten Zeiträume enthalten.<br><br>" +
                "Mit Hilfe der spektralen Informationen der Komposite können wertvolle Informationen generiert werden. Diese stellen eine sinnvolle Ergänzung bestehender Bodenkarten und -datenbanken dar, da die SCMaP Bodeninformationen eine sehr hohe räumliche und zeitliche Auflösung haben. Beispielweise sind durch eine geeignete Wahl der Länge der Kompositzeiträume (fünf Jahre) Veränderungen der Böden in Deutschland seit 1984 rückblickend analysierbar."
        },
        2: {
            layerId: 2,
            name: "Häufigkeit eines unbedeckten Bodens",
            subname: "Zeitraum 1984-2014, © DLR",
            active: false,
            url: "https://geoservice.dlr.de/eoc/land/wms?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=SCMAP_SF_LS_1984-2014&styles=",
            func: WmsLayer,
            attribution: "© DLR (2020)",
            legendUrl: "/static/legends/Soil-Frequency_Legende.png",
            infoText: "Der Layer zeigt wie lange eine ackerbaulich genutzte Fläche im betrachteten Zeitraum keine Vegetationsbedeckung aufweist. Dargestellt ist der prozentuale Anteil an unbedecktem Boden pro Pixel im jeweiligen Zeitraum (1984-2014). "
        },
        3: {
            layerId: 3,
            name: "Vorkommen unbedeckte Böden",
            subname: "Zeitraum 1984-2014, © DLR",
            active: false,
            url: "https://geoservice.dlr.de/eoc/land/wms?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=SCMAP_SC_LS_1984-2014&styles=",
            func: WmsLayer,
            attribution: "© DLR (2020)",
            legendUrl: "/static/legends/exposed_soil_Legende.png",
            infoText: "Die Maske zeigt alle Flächen, die im betrachteten Zeitraum (1984-2014) als unbedeckter Boden identifiziert werden. SCMaP ermittelt alle Gebiete, die einen Wechsel von vegetationsbedeckt zu vegetationslos zeigen und identifiziert diese als unbedeckte Böden. Die so abgeleiteten Flächen repräsentieren die ackerbaulich genutzten Flächen in Deutschland (ohne Dauergrünland)."
        },
        4: {
            layerId: 4,
            name: "Physiko-chemische Filterwirkung",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D1000_Physiko-chemische Filterwirkung&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D1000_Physiko-chemische Filterwirkung&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Als physiko-chemische Filterwirkung wird die Fähigkeit eines Bodens bezeichnet, gelöste Stoffe aus der Bodenlösung zu absorbieren. Die Absorptionsleistung hängt vor allem von der Oberflächenaktivität der Bodenteilchen ab. Die Bewertung erfolgt auf Basis von Bodenart und Grundwasserflurabstand. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        5: {
            layerId: 5,
            name: "Mechanische Filterwirkung",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D1000_Mechanische Filterwirkung&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D1000_Mechanische Filterwirkung&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Unter dem Begriff mechanische Filterwirkung wird die Fähigkeit des Bodens verstanden, eine Suspension mechanisch zu klären, entweder als Oberflächen- oder Haufwerkfilter. Die Bewertung erfolgt auf Basis von Bodenart, Grundwasserflurabstand und Klimatischer Wasserbilanz (Niederschlag - Verdunstung). Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        6: {
            layerId: 6,
            name: "Bodenqualitätsbewertung",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D1000_Soil Quality Rating&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D1000_Soil Quality Rating&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Das Müncheberger Soil Quality Rating (SQR) wurde vom Leibniz-Zentrum für Agrarlandschaftsforschung (ZALF) entwickelt. Das SQR ist ein Verfahren zur Bewertung der Eignung von Standorten für die landwirtschaftliche Nutzung und dient der Abschätzung des potentiellen Ertrags. Die Bewertung erfolgt auf Basis von Bodenart, Tiefe A-Horizont, Gefügestruktur des Oberbodens, Verdichtung des Unterbodens, Durchwurzelungstiefe, Wasserverfügbarkeit, Bodenfeuchte, Hangneigung, pH-Wert, Gründigkeit, Dürrerisiko und Skelettgehalt. Referenz: Müller, L., Schindler, U., Behrendt, A., Eulenstein, F., Dannowski, R. (2007) The Müncheberg Soil Quality Rating (SQR). Field manual for detecting and assessing properties and limitations of soils for cropping and grazing."
        },
        7: {
            layerId: 7,
            name: "Biotisches Ertragspotential",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D1000_Biotisches Ertragspotential&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D1000_Biotisches Ertragspotential&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Das biotische Ertragspotential beschreibt das Leistungsvermögen des Landschaftshaushaltes Biomasse zu erzeugen und dessen ständige Wiederholbarkeit zu gewährleisten. Die Bewertung erfolgt auf Basis von nutzbarer Feldkapazität, Bodenart, Skelettgehalt, Hangneigung, Landnutzung, Grundwasserflurabstand, Niederschlagsmenge, Jahresmitteltemperatur, Grüdigkeit, Staunässegrad und Erosionsgefährdung. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        8: {
            layerId: 8,
            name: "Erosionswiderstand Wind",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D1000_Erosionswiderstand Wind&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D1000_Erosionswiderstand Wind&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Erosionswiderstandsfunktion beschreibt die Widerstandsfähigkeit des Bodens gegenüber Abtragung durch Wind und das Leistungsvermögen des Landschaftshaushaltes Bodenerosion, die durch Bewirtschaftung über das natürliche Maß hinaus geht, entgegenzuwirken. Die Bewertung erfolgt für Mineralböden auf Basis von Bodenart, Humusgehalt und Grundwasserflurabstand, für Moorböden auf Basis von Torfart und Zersetzungsstufe. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        9: {
            layerId: 9,
            name: "Erosionswiderstand Wasser",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D1000_Erosionswiderstand Wasser&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D1000_Erosionswiderstand Wasser&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Erosionswiderstandsfunktion beschreibt die Widerstandsfähigkeit des Bodens gegenüber Abtragung durch Niederschlagswasser und das Leistungsvermögen des Landschaftshaushaltes Bodenerosion, die durch Bewirtschaftung über das natürliche Maß hinaus geht, entgegenzuwirken. Die Bewertung erfolgt auf Basis von Bodenart, Humusgehalt, Skelettgehalt, Hangneigung, Landnutzung, Sommerniederschlag (Mai bis Oktober), Gründigkeit und Wölbung. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        10: {
            layerId: 10,
            name: "Abflussregulationsfunktion",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D1000_Abflussregulationsfunktion&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D1000_Abflussregulationsfunktion&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Abflussregulationsfunktion beschreibt das Leistungsvermögen des Landschaftshaushaltes Oberflächenwasser zurückzuhalten, Direktabfluss und Abflussspitzen zu verringern und Abflussbedingungen auszugleichen. Die Bewertung erfolgt auf Basis von nutzbarer Feldkapazität, Bodenart, Skelettgehalt, Hangneigung, Landnutzung, Grundwasserflurabstand und Hydromorphie. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        11: {
            layerId: 11,
            name: "Physiko-chemische Filterwirkung, BW",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=BW_Physiko-chemische Filterwirkung&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=BW_Physiko-chemische Filterwirkung&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Als physiko-chemische Filterwirkung wird die Fähigkeit eines Bodens bezeichnet, gelöste Stoffe aus der Bodenlösung zu absorbieren. Die Absorptionsleistung hängt vor allem von der Oberflächenaktivität der Bodenteilchen ab. Die Bewertung erfolgt auf Basis von Bodenart und Grundwasserflurabstand. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        13: {
            layerId: 13,
            name: "Bodenqualitätsbewertung, BW",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=BW_Soil Quality Rating&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=BW_Soil Quality Rating&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Das Müncheberger Soil Quality Rating (SQR) wurde vom Leibniz-Zentrum für Agrarlandschaftsforschung (ZALF) entwickelt. Das SQR ist ein Verfahren zur Bewertung der Eignung von Standorten für die landwirtschaftliche Nutzung und dient der Abschätzung des potentiellen Ertrags. Die Bewertung erfolgt auf Basis von Bodenart, Tiefe A-Horizont, Gefügestruktur des Oberbodens, Verdichtung des Unterbodens, Durchwurzelungstiefe, Wasserverfügbarkeit, Bodenfeuchte, Hangneigung, pH-Wert, Gründigkeit, Dürrerisiko und Skelettgehalt. Referenz: Müller, L., Schindler, U., Behrendt, A., Eulenstein, F., Dannowski, R. (2007) The Müncheberg Soil Quality Rating (SQR). Field manual for detecting and assessing properties and limitations of soils for cropping and grazing."
        },
        14: {
            layerId: 14,
            name: "Biotisches Ertragspotential, BW",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=BW_Biotisches Ertragspotential&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=BW_Biotisches Ertragspotential&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Das biotische Ertragspotential beschreibt das Leistungsvermögen des Landschaftshaushaltes Biomasse zu erzeugen und dessen ständige Wiederholbarkeit zu gewährleisten. Die Bewertung erfolgt auf Basis von nutzbarer Feldkapazität, Bodenart, Skelettgehalt, Hangneigung, Landnutzung, Grundwasserflurabstand, Niederschlagsmenge, Jahresmitteltemperatur, Grüdigkeit, Staunässegrad und Erosionsgefährdung. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        15: {
            layerId: 15,
            name: "Erosionswiderstand Wind, BW",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=BW_Erosionswiderstand Wind&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=BW_Erosionswiderstand Wind&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Erosionswiderstandsfunktion beschreibt die Widerstandsfähigkeit des Bodens gegenüber Abtragung durch Wind und das Leistungsvermögen des Landschaftshaushaltes Bodenerosion, die durch Bewirtschaftung über das natürliche Maß hinaus geht, entgegenzuwirken. Die Bewertung erfolgt für Mineralböden auf Basis von Bodenart, Humusgehalt und Grundwasserflurabstand, für Moorböden auf Basis von Torfart und Zersetzungsstufe. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        16: {
            layerId: 16,
            name: "Erosionswiderstand Wasser, BW",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=BW_Erosionswiderstand Wasser&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=BW_Erosionswiderstand Wasser&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Erosionswiderstandsfunktion beschreibt die Widerstandsfähigkeit des Bodens gegenüber Abtragung durch Niederschlagswasser und das Leistungsvermögen des Landschaftshaushaltes Bodenerosion, die durch Bewirtschaftung über das natürliche Maß hinaus geht, entgegenzuwirken. Die Bewertung erfolgt auf Basis von Bodenart, Humusgehalt, Skelettgehalt, Hangneigung, Landnutzung, Sommerniederschlag (Mai bis Oktober), Gründigkeit und Wölbung. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        17: {
            layerId: 17,
            name: "Abflussregulationsfunktion, BW",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=BW_Abflussregulationsfunktion&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=BW_Abflussregulationsfunktion&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Abflussregulationsfunktion beschreibt das Leistungsvermögen des Landschaftshaushaltes Oberflächenwasser zurückzuhalten, Direktabfluss und Abflussspitzen zu verringern und Abflussbedingungen auszugleichen. Die Bewertung erfolgt auf Basis von nutzbarer Feldkapazität, Bodenart, Skelettgehalt, Hangneigung, Landnutzung, Grundwasserflurabstand und Hydromorphie. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        18: {
            layerId: 18,
            name: "LUCAS topsoil data",
            subname: "2009, JRC (ESDAC)",
            active: false,
            attribution: "JRC (ESDAC)",
            url: "/static/geodata/lucas_spectral.geojson",
            func: GeojsonLayer,
            promoteId: "ID",
            infoText: "<p>Data from the 2009 LUCAS campaign soil component containing soil properties data (clay, silt and sand content, coarse fragments, pH, organic carbon content, CaCO3, nitrogen, phosphorous, potassium, cation exchane capacity) and multispectral absorbance data.</p><p><a href='https://esdac.jrc.ec.europa.eu/content/lucas-2009-topsoil-data'>https://esdac.jrc.ec.europa.eu/content/lucas-2009-topsoil-data</a></p><p>The documentation (citation) associated to the data is available from the reports/publications:</p><p>- Orgiazzi, A., Ballabio, C., Panagos, P., Jones, A., Fernández-Ugalde, O. 2018. LUCAS Soil, the largest expandable soil dataset for Europe: A review. European Journal of Soil Science, 69(1): 140-153, DOI: 10.1111/ejss.12499<br>- Tóth, G., Jones, A., Montanarella, L. (eds.) 2013. LUCAS Topsoil Survey. Methodology, data and results. JRC Technical Reports. Luxembourg. Publications Office of the European Union, EUR26102 – Scientific and Technical Research series – ISSN 1831-9424 (online); ISBN 978-92-79-32542-7; doi: 10.2788/97922<br>- Toth G., Jones A., Montanarella L. (2013) The LUCAS topsoil database and derived information on the regional variability of cropland topsoil properties in the European Union. Environmental Monitoring and Assessment, 185 (9), pp. 7409-7425.</p>"
        },
        19: {
            layerId: 19,
            name: "Digitales Geländemodell 200",
            subname: "Relief (DGM200), © BGR",
            active: false,
            url: "https://sgx.geodatenzentrum.de/wms_dgm200?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=relief&styles=",
            func: WmsLayer,
            attribution: "© GeoBasis-DE / BKG (2020)"
        },
        21: {
            layerId: 21,
            name: "CORINE Land Cover 5 ha",
            subname: "Stand 2018, © BGR",
            active: false,
            url: "https://sgx.geodatenzentrum.de/wms_clc5_2018?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=clc5&styles=",
            func: WmsLayer,
            attribution: "© GeoBasis-DE / BKG (2020)",
            legendUrl: "https://sgx.geodatenzentrum.de/wms_clc5_2018?styles=&layer=clc5&service=WMS&format=image%2Fpng&sld_version=1.1.0&request=GetLegendGraphic&version=1.1.1"
        },
        22: {
            layerId: 22,
            name: "Verwaltungsgebiete",
            subname: "© BGR",
            active: false,
            url: "https://sgx.geodatenzentrum.de/wms_vg250?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=vg250_krs,vg250_lan&styles=",
            func: WmsLayer,
            attribution: "© GeoBasis-DE / BKG (2020)"
        },
        23: {
            layerId: 23,
            name: "Bodenübersichtskarte",
            subname: "1:1.000.000 (BÜK1000), © BGR",
            url: "https://services.bgr.de/wms/boden/buek1000de/?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=0&styles=",
            func: WmsLayer,
            active: false,
            attribution: "© GeoBasis-DE / BKG (2020)",
            legendUrl: "https://services.bgr.de/wms/boden/buek1000de/?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=0"
        },
        24: {
            layerId: 24,
            name: "Bodenübersichtskarte",
            subname: "1:200.000 (BÜK200), © BGR",
            url: "https://services.bgr.de/wms/boden/buek200/?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=55,56&styles=",
            func: WmsLayer,
            active: false,
            attribution: "© GeoBasis-DE / BKG (2020)",
            legendUrl: "https://services.bgr.de/wms/boden/buek200/?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=0"
        },
        25: {
            layerId: 25,
            name: "Gruppen der Bodenausgangsgesteine",
            subname: "1:5.000.000 (BAG5000), © BGR",
            url: "https://services.bgr.de/wms/boden/bag5000/?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=0&styles=",
            func: WmsLayer,
            active: false,
            attribution: "© GeoBasis-DE / BKG (2020)",
            legendUrl: "https://services.bgr.de/wms/boden/bag5000/?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=0"
        },
        26: {
            layerId: 26,
            name: "Bodenregionen und Bodengroßlandschaften",
            subname: "1:5.000.000 (BGL5000), © BGR",
            active: false,
            url: "https://services.bgr.de/wms/boden/bgl5000/?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=0&styles=",
            func: WmsLayer,
            attribution: "© GeoBasis-DE / BKG (2020)",
            legendUrl: "https://services.bgr.de/wms/boden/bgl5000/?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=0"
        },
        27: {
            layerId: 27,
            name: "Bodenarten in Oberböden",
            subname: "1:1.000.000 (BOART1000OB), © BGR",
            active: false,
            url: "https://services.bgr.de/wms/boden/boart1000ob/?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=0&styles=",
            func: WmsLayer,
            attribution: "© GeoBasis-DE / BKG (2020)",
            legendUrl: "https://services.bgr.de/wms/boden/boart1000ob/?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=0"
        },
        28: {
            layerId: 28,
            name: "Gehalte an organischer Substanz in Oberböden",
            subname: "1:1.000.000 (HUMUS1000OB), © BGR",
            active: false,
            url: "https://services.bgr.de/wms/boden/humus1000ob/?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=0&styles=",
            func: WmsLayer,
            attribution: "© GeoBasis-DE / BKG (2020)",
            legendUrl: "https://services.bgr.de/wms/boden/boart1000ob/?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=0"
        },
        29: {
            layerId: 29,
            name: "Ackerbauliches Ertragspotential der Böden",
            subname: "© BGR",
            active: false,
            url: "https://services.bgr.de/wms/boden/sqr1000/?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=32&styles=",
            func: WmsLayer,
            attribution: "© GeoBasis-DE / BKG (2020)",
            legendUrl: "https://services.bgr.de/wms/boden/sqr1000/?request=GetLegendGraphic%26version=1.3.0%26format=image/png%26layer=32"
        },
        30: {
            layerId: 30,
            name: "Reflektion, 10 m",
            subname: "2015-2020, Echtfarben, © EOMAP",
            active: false,
            url: "https://public-geodata.s3.eu-central-1.amazonaws.com/soil-de/soil_rgb_10m/{z}/{x}/{y}.png",
            func: WmsLayer,
            attribution: "© EOMAP (2020)",
            infoText: "Echtfarbendarstellung der Oberflächenreflektion der unbedeckten Böden. Es handelt sich um einen zeitlich und statistisch zusammengesetzten  Datensatz der die maximale Ausdehnung von unbedeckten Böden des Zeitraums von 2015-2020 darstellt. Die Daten beruhen auf dem Sentinel-2 Datenarchiv und haben eine räumliche Auflösung der Daten ist 10m."
        },
        31: {
            layerId: 31,
            name: "Reflektion, 10 m, Enhanced",
            subname: "2015-2020, Echtfarben, © EOMAP",
            active: false,
            url: "https://public-geodata.s3.eu-central-1.amazonaws.com/soil-de/soil_rgb_enhance_daily_10m/{z}/{x}/{y}.png",
            func: WmsLayer,
            attribution: "© EOMAP (2020)",
            infoText: "Extreme Farbspreizung der Echtfarbendarstellung der Oberflächenreflektion der unbedeckten Böden. Es handelt sich um einen zeitlich und statistisch zusammengesetzten Datensatz der die maximale Ausdehnung von unbedeckten Böden des Zeitraums von 2015-2020 darstellt. Die Daten beruhen auf dem Sentinel-2 Datenarchiv und haben eine räumliche Auflösung der Daten ist 10m."
        },
        32: {
            layerId: 32,
            name: "Reflektion, 500 m",
            subname: "2015-2020, Echtfarben, © EOMAP",
            active: false,
            url: "https://public-geodata.s3.eu-central-1.amazonaws.com/soil-de/soil_rgb_500m/{z}/{x}/{y}.png",
            func: WmsLayer,
            attribution: "© EOMAP (2020)",
            infoText: "Echtfarbendarstellung der Oberflächenreflektion der unbedeckten Böden. Es handelt sich um einen zeitlich und statistisch zusammengesetzten Datensatz der die maximale Ausdehnung von unbedeckten Böden des Zeitraums von 2015-2020 darstellt. Die Daten beruhen auf dem Sentinel-2 Datenarchiv. Die Daten beruhen auf dem Sentinel-2 Datenarchiv und sind auf 500m vergröbert um eine Dt.-weite Darstellung zu vereinfachen."
        },
        33: {
            layerId: 33,
            name: "Reflektion, 500 m, Enhanced",
            subname: "2015-2020, Echtfarben, © EOMAP",
            active: false,
            url: "https://public-geodata.s3.eu-central-1.amazonaws.com/soil-de/soil_rgb_enhance_500m/{z}/{x}/{y}.png",
            func: WmsLayer,
            attribution: "© EOMAP (2020)",
            infoText: "Extreme Farbspreizung der Echtfarbendarstellung der Oberflächenreflektion der unbedeckten Böden. Es handelt sich um einen zeitlich und statistisch zusammengesetzten Datensatz der die maximale Ausdehnung von unbedeckten Böden des Zeitraums von 2015-2020 darstellt. Die Daten beruhen auf dem Sentinel-2 Datenarchiv und sind auf 500m vergröbert um eine Dt.-weite Darstellung zu vereinfachen."
        },
        34: {
            layerId: 34,
            name: "Corg [%]",
            subname: "1984-2014, Modelliert, © DLR",
            active: false,
            url: "https://rastless.api.eomap.com/layers/54fe196f-4005-4c63-b95b-fd9a5b7e5a11/1984_2014/tile/{z}/{x}/{y}.png?token=00068406-9883-4e4f-a1d9-90fa03025244",
            func: TilexyzLayer,
            legendUrl: "/static/legends/corg_legend.png",
            attribution: "© DLR (2021)",
            infoText: "Modellierte Corg Gehalte [%] unbedeckter Böden in Bayern. Die Modellierung basiert auf spektralen Informationen des SCMaP Bodenkomposits von 1984 bis 2014 und Analysen aus Feldproben des bayerischen Landesamts für Umwelt (LfU), der bayerischen Landesanstalt für Landwirtschaft (LfL) und der LUCAS (Land Use/Cover  Area frame statistical Survey) Bodenbeprobung des European Soil Data Center (ESDAC).<br><br>Ausführliche Beschreibung der Methodik, der verwendeten Daten und der Ergebnisse: Zepp, S.; Heiden, U.; Bachmann, M.; Wiesmeier, M.; Steininger, M.; van Wesemael, B. Estimation of Soil Organic Carbon Contents in Croplands of Bavaria from SCMaP Soil Reflectance Composites. Remote Sens. 2021, 13, 3141. https://doi.org/10.3390/rs13163141."
        },
        37: {
            layerId: 37,
            name: "Physiko-chemische Filterwirkung, NI",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=NI_Physiko-chemische Filterwirkung&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de:443/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=NI_Physiko-chemische Filterwirkung&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Als physiko-chemische Filterwirkung wird die Fähigkeit eines Bodens bezeichnet, gelöste Stoffe aus der Bodenlösung zu absorbieren. Die Absorptionsleistung hängt vor allem von der Oberflächenaktivität der Bodenteilchen ab. Die Bewertung erfolgt auf Basis von Bodenart und Grundwasserflurabstand. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229. "
        },
        38: {
            layerId: 38,
            name: "Mechanische Filterwirkung, NI",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=NI_Mechanische Filterwirkung&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de:443/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=NI_Mechanische Filterwirkung&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Unter dem Begriff mechanische Filterwirkung wird die Fähigkeit des Bodens verstanden, eine Suspension mechanisch zu klären, entweder als Oberflächen- oder Haufwerkfilter. Die Bewertung erfolgt auf Basis von Bodenart, Grundwasserflurabstand und Klimatischer Wasserbilanz (Niederschlag - Verdunstung). Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        39: {
            layerId: 39,
            name: "Biotisches Ertragspotential, NI",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=NI_Biotisches Ertragspotential&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de:443/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=NI_Biotisches Ertragspotential&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Das biotische Ertragspotential beschreibt das Leistungsvermögen des Landschaftshaushaltes Biomasse zu erzeugen und dessen ständige Wiederholbarkeit zu gewährleisten. Die Bewertung erfolgt auf Basis von nutzbarer Feldkapazität, Bodenart, Skelettgehalt, Hangneigung, Landnutzung, Grundwasserflurabstand, Niederschlagsmenge, Jahresmitteltemperatur, Grüdigkeit, Staunässegrad und Erosionsgefährdung. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        40: {
            layerId: 40,
            name: "Erosionswiderstand Wind, NI",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=NI_Erosionswiderstand Wind&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de:443/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=NI_Erosionswiderstand Wind&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Erosionswiderstandsfunktion beschreibt die Widerstandsfähigkeit des Bodens gegenüber Abtragung durch Wind und das Leistungsvermögen des Landschaftshaushaltes Bodenerosion, die durch Bewirtschaftung über das natürliche Maß hinaus geht, entgegenzuwirken. Die Bewertung erfolgt für Mineralböden auf Basis von Bodenart, Humusgehalt und Grundwasserflurabstand, für Moorböden auf Basis von Torfart und Zersetzungsstufe. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        41: {
            layerId: 41,
            name: "Erosionswiderstand Wasser, NI",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=NI_Erosionswiderstand Wasser&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de:443/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=NI_Erosionswiderstand Wasser&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Erosionswiderstandsfunktion beschreibt die Widerstandsfähigkeit des Bodens gegenüber Abtragung durch Niederschlagswasser und das Leistungsvermögen des Landschaftshaushaltes Bodenerosion, die durch Bewirtschaftung über das natürliche Maß hinaus geht, entgegenzuwirken. Die Bewertung erfolgt auf Basis von Bodenart, Humusgehalt, Skelettgehalt, Hangneigung, Landnutzung, Sommerniederschlag (Mai bis Oktober), Gründigkeit und Wölbung. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        42: {
            layerId: 42,
            name: "Abflussregulationsfunktion, NI",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=NI_Abflussregulationsfunktion&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de:443/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=NI_Abflussregulationsfunktion&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Abflussregulationsfunktion beschreibt das Leistungsvermögen des Landschaftshaushaltes Oberflächenwasser zurückzuhalten, Direktabfluss und Abflussspitzen zu verringern und Abflussbedingungen auszugleichen. Die Bewertung erfolgt auf Basis von nutzbarer Feldkapazität, Bodenart, Skelettgehalt, Hangneigung, Landnutzung, Grundwasserflurabstand und Hydromorphie. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        43: {
            layerId: 43,
            name: "Reflektion, 10 m",
            subname: "Sentinel-2, Echtfarben, © UOS",
            active: false,
            url: "https://public-geodata.s3.eu-central-1.amazonaws.com/soil-de-reflection-uos/{z}/{x}/{y}.png",
            func: WmsLayer,
            attribution: "© UOS (2022)",
            infoText: "Über den Zeitraum von 2015-2020 wurden mittels statistischer Aggregation der Sentinel-2 Daten wolkenfreie, unbedeckte Böden ermittelt. Das Hauptprodukt stellt ein wolkenfreies Reflektanzkomposit dar. Mit Hilfe der spektralen Informationen der Komposite können wertvolle Informationen generiert werden. Diese stellen eine sinnvolle Ergänzung bestehender Bodenkarten und -datenbanken dar."
        },
        44: {
            layerId: 44,
            name: "Physiko-chemische Filterwirkung",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D200_physikochem_filter&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D200_physikochem_filter&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Als physiko-chemische Filterwirkung wird die Fähigkeit eines Bodens bezeichnet, gelöste Stoffe aus der Bodenlösung zu absorbieren. Die Absorptionsleistung hängt vor allem von der Oberflächenaktivität der Bodenteilchen ab. Die Bewertung erfolgt auf Basis von Bodenart und Grundwasserflurabstand. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229. "
        },
        45: {
            layerId: 45,
            name: "Mechanische Filterwirkung",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D200_mech_filter&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de:443/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D200_mech_filter&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Unter dem Begriff mechanische Filterwirkung wird die Fähigkeit des Bodens verstanden, eine Suspension mechanisch zu klären, entweder als Oberflächen- oder Haufwerkfilter. Die Bewertung erfolgt auf Basis von Bodenart, Grundwasserflurabstand und Klimatischer Wasserbilanz (Niederschlag - Verdunstung). Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        46: {
            layerId: 46,
            name: "Biotisches Ertragspotential",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D200_ertragspotential&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de:443/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D200_ertragspotential&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Das biotische Ertragspotential beschreibt das Leistungsvermögen des Landschaftshaushaltes Biomasse zu erzeugen und dessen ständige Wiederholbarkeit zu gewährleisten. Die Bewertung erfolgt auf Basis von nutzbarer Feldkapazität, Bodenart, Skelettgehalt, Hangneigung, Landnutzung, Grundwasserflurabstand, Niederschlagsmenge, Jahresmitteltemperatur, Grüdigkeit, Staunässegrad und Erosionsgefährdung. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        47: {
            layerId: 47,
            name: "Erosionswiderstand Wind",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D200_erosionswiderstand_wind&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de:443/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D200_erosionswiderstand_wind&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Erosionswiderstandsfunktion beschreibt die Widerstandsfähigkeit des Bodens gegenüber Abtragung durch Wind und das Leistungsvermögen des Landschaftshaushaltes Bodenerosion, die durch Bewirtschaftung über das natürliche Maß hinaus geht, entgegenzuwirken. Die Bewertung erfolgt für Mineralböden auf Basis von Bodenart, Humusgehalt und Grundwasserflurabstand, für Moorböden auf Basis von Torfart und Zersetzungsstufe. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        48: {
            layerId: 48,
            name: "Erosionswiderstand Wasser",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D200_erosionswiderstand_wasser&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de:443/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D200_erosionswiderstand_wasser&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Erosionswiderstandsfunktion beschreibt die Widerstandsfähigkeit des Bodens gegenüber Abtragung durch Niederschlagswasser und das Leistungsvermögen des Landschaftshaushaltes Bodenerosion, die durch Bewirtschaftung über das natürliche Maß hinaus geht, entgegenzuwirken. Die Bewertung erfolgt auf Basis von Bodenart, Humusgehalt, Skelettgehalt, Hangneigung, Landnutzung, Sommerniederschlag (Mai bis Oktober), Gründigkeit und Wölbung. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        49: {
            layerId: 49,
            name: "Abflussregulationsfunktion",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D200_abflussregulation&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de:443/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D200_abflussregulation&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Die Abflussregulationsfunktion beschreibt das Leistungsvermögen des Landschaftshaushaltes Oberflächenwasser zurückzuhalten, Direktabfluss und Abflussspitzen zu verringern und Abflussbedingungen auszugleichen. Die Bewertung erfolgt auf Basis von nutzbarer Feldkapazität, Bodenart, Skelettgehalt, Hangneigung, Landnutzung, Grundwasserflurabstand und Hydromorphie. Referenz: Marks, R., Müller, M. J., Leser, H., Klink, H.-J. (Hrsg.) (1992) Anleitung zur Bewertung des Leistungsvermögens des Landschaftshaushaltes (BA-LVL). Forschungen zur deutschen Landeskunde, Band 229."
        },
        50: {
            layerId: 50,
            name: "SQR",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D200_sqr_2018&styles=",
            func: WmsLayer,
            attribution: "© JKI (2020)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D200_sqr_2018&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Das Müncheberger Soil Quality Rating (SQR) wurde vom Leibniz-Zentrum für Agrarlandschaftsforschung (ZALF) entwickelt. Das SQR ist ein Verfahren zur Bewertung der Eignung von Standorten für die landwirtschaftliche Nutzung und dient der Abschätzung des potentiellen Ertrags. Die Bewertung erfolgt auf Basis von Landnutzung (Corine Land Cover 2018), Bodenart, Tiefe A-Horizont, Gefügestruktur des Oberbodens, Verdichtung des Unterbodens, Durchwurzelungstiefe, Wasserverfügbarkeit, Bodenfeuchte, Hangneigung, pH-Wert, Gründigkeit, Dürrerisiko und Skelettgehalt. Referenz: Müller, L., Schindler, U., Behrendt, A., Eulenstein, F., Dannowski, R. (2007) The Müncheberg Soil Quality Rating (SQR). Field manual for detecting and assessing properties and limitations of soils for cropping and grazing. European Union, Copernicus Land Monitoring Service 2018, European Environment Agency (EEA)."
        },
        51: {
            layerId: 51,
            name: "Oberbodenfeuchte [%]",
            subname: "provided by Copernicus Land",
            active: false,
            url: "https://rastless.api.eomap.com/layers/ssm-daily-soil-6b13c7bfcf7a/{timestamp}/tile/{z}/{x}/{y}.png?token=c8c9633d-bf33-41d6-ab38-20666297ef92",
            urlTimeLayers: "https://rastless.api.eomap.com/layers/ssm-daily-soil-6b13c7bfcf7a/steps?token=c8c9633d-bf33-41d6-ab38-20666297ef92",
            func: TilexyzLayer,
            attribution: "© EOMAP (2020)",
            legendUrl: "/static/legends/soilmoisture.png",
            infoText: "Surface Soil Moisture (SSM) ist der relative Wassergehalt der oberen  Zentimeter des Bodens und beschreibt, wie feucht oder trocken der Boden in seiner obersten Schicht ist, ausgedrückt in Prozent Wassersättigung. Sie wird von Satellitenradarsensoren gemessen und erlaubt Einblicke in lokale Niederschlagseinflüsse und Bodenverhältnisse.\n" +
                "Datenquelle: Surface Soil Moisture (SSM), Copernicus Land. URL: https://land.copernicus.eu/global/products/ssm \n" +
                "Veröffentlichung: Bauer-Marschallinger, B. ; Freeman, V. ; Cao, S. ; Paulik, C. ; Schaufler, S. ; Stachl, T. ; Modanesi, S. ; Massari, C. ; Ciabatta, L. ; Brocca, L. ; Wagner, W. Toward Global Soil Moisture Monitoring With Sentinel-1: Harnessing Assets and Overcoming Obstacles. IEEE Transactions on Geoscience and Remote Sensing 2019, 1 - 20. " +
                "DOI 10.1109/TGRS.2018.2858004",
            timestamp: "",
            temporalResolution: "",
            keyLayer: "ssm-daily-soil-6b13c7bfcf7a",//key Layout for Rest-Api service
            plotLayout: {
                title: "Oberbodenfeuchte, nFK (%)",
                xaxis: {
                    title: "Zeitachse",
                },
                yaxis: {
                    title: "Oberbodenfeuchte, nFK (%)",
                }
            }
        },
        52: {
            layerId: 52,
            name: "Reflektion, 10 m",
            subname: "Sentinel-2, Dynamisch, © UOS",
            active: false,
            url: "https://rastless.api.eomap.com/layers/soil-de-uos-reflectance-composite/1/tile/{z}/{x}/{y}.png?token=c8c9633d-bf33-41d6-ab38-20666297ef92&transparent_black_pixel=true",
            bands: ["b3", "b2", "b1"],
            func: DynamicBandLayer,
            attribution: "© UOS (2022)",
            infoText: "Über den Zeitraum von 2015-2020 wurden mittels statistischer Aggregation der Sentinel-2 Daten wolkenfreie, unbedeckte Böden ermittelt. Das Hauptprodukt stellt ein wolkenfreies Reflektanzkomposit dar. Mit Hilfe der spektralen Informationen der Komposite können wertvolle Informationen generiert werden. Diese stellen eine sinnvolle Ergänzung bestehender Bodenkarten und -datenbanken dar."
        },
        53: {
            layerId: 53,
            name: "Bodenverlust [%]",
            subname: "© JKI",
            active: false,
            url: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.3.0&request=GetMap&crs=EPSG:3857&transparent=true&width=256&height=256&layers=D_Bodenverlust [%]&styles=",
            func: WmsLayer,
            attribution: "© JKI (2023)",
            legendUrl: "https://wms.flf.julius-kuehn.de/cgi-bin/SOIL-DE/qgis_mapserv.fcgi?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=D_Bodenverlust [%]&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
            infoText: "Zur Ermittlung des quantitativen Bodenverlustes an landwirtschaftlicher Fläche in Deutschland von 2006-2015 wurden die hochauflösenden Imperviousness-Layer aus dem Copernicus Land Monitoring Service (CLMS) der Europäischen Union verwendet (EU, 2023). Die Rate der Bodenversiegelung in diesen Schichten ist ein Produkt der automatischen Ableitung auf der Grundlage des kalibrierten normalisierten Differenzvegetationsindex (NDVI). Bei der Berechnung wurden die klassifizierte Änderungs-Layer (IMCC) 2006-2009, 2009-2012 und 2012-2015 berücksichtigt. Das Änderungsprodukt der Versiegelung (IMCC) hat eine Auflösung von 20 m und wird in sechs verschiedene Kategorien eingeteilt: unverändert keine Versiegelung, Neuversiegelung, Verlust von Deckung, unveränderte Versiegelung, erhöhte Versiegelung, verringerte Versiegelung (EEA, 2018). Hier wurden die als Neuversiegelung eingestuften Flächen der IMCC-Schichten untersucht und mit den landwirtschaftlich genutzten Flächen nach CORINE Land Cover (CLC, EU, 2023) gemäß dem jeweiligen CLC-Jahr verschnitten: 2006-2009 und 2009-2012 mit CLC 2006 und 2012-2015 unter Verwendung von CLC 2012. Das Endprodukt ist der kumulierte Bodenverlust landwirtschaftlicher Flächen, der als Prozentsatz versiegelter Fläche je Rasterzelle in einem 10 × 10 km Raster dargestellt wird. Der Begriff Bodenversiegelung wird hier als Beschreibung und Synonym für den Verlust von Boden durch bebaute Flächen im Vergleich zur ursprünglichen landwirtschaftlichen Nutzung der Flächen verwendet. Referenzen: European Union (2023) Copernicus Land Monitoring Service 2023, European Environment Agency (EEA). https://land.copernicus.eu; European Environment Agency (EEA, 2018) Copernicus Land Monitoring Service – High Resolution Layer Imperviousness: Product specifications document. https://land.copernicus.eu/user-corner/technical-library/hrl-imperviousness-technical-document-prod-2015"
        },

    },
    activeLayerId: null,
    activeLayerList: []
}

const getters = {
    layerIsActive: state => {
        if (state.activeLayerId !== null) {
            return "legendUrl" in state.layerInfos[state.activeLayerId]
        }
        return false
    },
    legendUrl: state => {
        if (state.activeLayerId !== null) {
            if ("legendUrl" in state.layerInfos[state.activeLayerId]) {
                return state.layerInfos[state.activeLayerId].legendUrl
            }
        }
        return ""
    },
    layerInfo: state => layerId => {
        return state.layerInfos[layerId]
    }
}

const actions = {
    toggle_layer({commit}, layerId) {
        commit("TOGGLE_LAYER_BUTTON", layerId)
    },
    change_layer({commit}, {datetime, layerId}) {
        commit("CHANGE_LAYER_BUTTON", {datetime, layerId})
    },
    set_layer_datetime({commit}, {datetime, layerId}) {
        commit("SET_LAYER_DATETIME", {datetime, layerId})
    },
    set_temporal_resolution({commit}, {temporalResolution, layerId}) {
        commit("SET_TEMPORAL_RESOLUTION", {temporalResolution, layerId})
    },
    update_bands({commit}, {bands, layerId}) {
        commit("SET_BANDS", {bands, layerId})
        commit("UPDATE_LAYER", layerId)
    }
}

const mutations = {
    TOGGLE_LAYER_BUTTON(state, layerId) {
        let newLayer = state.layerInfos[layerId]
        let newLayerFunc = new newLayer.func(newLayer, this)
        if (newLayer.active) {
            newLayerFunc.delete()
            newLayer.active = false
            state.activeLayerList = state.activeLayerList.filter(item => item !== layerId)
            if (state.activeLayerList.length > 0) {
                state.activeLayerId = state.activeLayerList[state.activeLayerList.length - 1]
            } else {
                state.activeLayerId = null
            }
        } else {
            if ('timestamp' in newLayer) {
                newLayerFunc.set(newLayer.timestamp)
            }
            newLayerFunc.add()
            newLayer.active = true
            state.activeLayerList.push(layerId)
            state.activeLayerId = layerId
        }
    },
    CHANGE_LAYER_BUTTON(state, {datetime, layerId}) {
        let layer = state.layerInfos[layerId]
        let layerFunc = new layer.func(layer, this)
        layerFunc.set(datetime)
        layerFunc.update()
    },
    UPDATE_LAYER(state, layerId) {
        let layer = state.layerInfos[layerId]
        let layerFunc = new layer.func(layer, this)
        layerFunc.update()
    },
    SET_LAYER_DATETIME(state, {datetime, layerId}) {
        state.layerInfos[layerId].timestamp = datetime
    },
    SET_TEMPORAL_RESOLUTION(state, {temporalResolution, layerId}) {
        state.layerInfos[layerId].temporalResolution = temporalResolution
    },
    SET_BANDS(state, {bands, layerId}) {
        state.layerInfos[layerId].bands = bands
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};